import { Component, inject, Inject, Input, PLATFORM_ID } from '@angular/core'

import { MenuItemComponent } from './components/menu-item.component'
import { MegaMenuColumnComponent } from './components/mega-menu-column.component'
import { splitArray } from 'src/app/utils'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'
import type { MenuItemType } from 'src/app/common/menu-items'
import { CommonModule, isPlatformBrowser } from '@angular/common'
import { basePath } from '@states/constants'
import { NavigationStart,Router } from '@angular/router'
import { MenuService } from '@helpers/utils'

@Component({
  selector: 'app-menu',
  imports: [
    MenuItemComponent,
    MegaMenuColumnComponent,
    NgbDropdownModule,
    CommonModule,
  ],
  templateUrl: './app-menu.component.html'
})
export class AppMenuComponent {
  @Input() theme: string = ''

  menuItems: MenuItemType[] = [];
  splitArray = splitArray
  isBrowser = true
  activeMenuItems: string[] = []
  trimmedURL!: string
  private menuService = inject(MenuService)
  private router = inject(Router)

  matchingMenuItem: MenuItemType | undefined
  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.isBrowser = isPlatformBrowser(this.platformId)
  }

  ngOnInit(): void {
    this.menuItems = this.menuService.getAppMenuItems()

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        console.log('Navigation started:', event.url); // Log the URL
        this.setActiveMenu(event.url);
      }
    });
  }
  normalizeUrl(url: string): string {
    return url.replace(/^\/+/, '/'); 
  }
  setActiveMenu(url: string): void {
    if (this.isBrowser) {
      this.trimmedURL = location.pathname
        .replace(basePath !== '' ? basePath + '/' : '', '/')
        .replace(/^\/+/, '/'); // Normalize leading slashes
    }

  
    const matchingMenuItem = this.menuService.getMenuItemFromURL(
      this.menuItems,
      this.trimmedURL
    );
  
    if (matchingMenuItem) {
  
      const activeMt = this.menuService.findMenuItem(
        this.menuItems,
        matchingMenuItem.key
      );
      if (activeMt) {
        this.activeMenuItems = [
          activeMt.key,
          ...this.menuService.findAllParent(this.menuItems, activeMt),
        ];
      }
    } 
  }
  

  getActiveClass(item: MenuItemType) {
    return this.activeMenuItems?.includes(item.key) ? ' active' : '';
  }
}
